(function () {
  if (window.__pdpNavInit) return;
  window.__pdpNavInit = true;

  var EXTRA_GAP = 14;

  function isRenderable(el) {
    return !!el && el.getClientRects().length > 0;
  }

  function resolveTarget(value) {
    if (/[.\s>#\[]/.test(value.charAt(0)) || value.indexOf(' ') !== -1) {
      try {
        var bySelector = document.querySelector(value);
        return isRenderable(bySelector) ? bySelector : null;
      } catch (e) {
        return null;
      }
    }

    var byId = document.getElementById(value);
    if (isRenderable(byId)) return byId;

    var byShopifySection = document.getElementById('shopify-section-' + value);
    if (isRenderable(byShopifySection)) return byShopifySection;

    var dataAttrMatches = document.querySelectorAll('[data-section-id="' + value + '"]');
    for (var i = 0; i < dataAttrMatches.length; i++) {
      if (isRenderable(dataAttrMatches[i])) return dataAttrMatches[i];
    }

    var byClass = document.getElementsByClassName(value)[0];
    if (isRenderable(byClass)) return byClass;

    return null;
  }

  function getScrollY() {
    return document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset || 0;
  }

  function getHeaderOffset() {
    var header = document.querySelector('.site-header__outer-wrapper');
    if (!header) return 0;
    var position = window.getComputedStyle(header).position;
    if (position === 'sticky' || position === 'fixed') {
      return header.getBoundingClientRect().height;
    }
    return 0;
  }

  class PdpNav {
    constructor(nav) {
      this.nav = nav;
      this.track = nav.querySelector('[data-pdp-nav-track]') || nav;
      this.links = Array.prototype.slice.call(nav.querySelectorAll('[data-pdp-nav-link]'));
      this.revealPercent = parseFloat(nav.dataset.revealPercent);
      if (isNaN(this.revealPercent)) this.revealPercent = 75;

      this.items = [];
      this.activeLink = null;
      this.activeTarget = null;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onClick = this.onClick.bind(this);

      this.resolveItems();
      this.position();
      this.update();
      this.bindEvents();
      this.watchForLateContent();
    }

    resolveItems() {
      this.items = [];
      for (var i = 0; i < this.links.length; i++) {
        var link = this.links[i];
        var target = resolveTarget(link.dataset.t);
        if (target) {
          this.items.push({ link: link, target: target });
          link.classList.remove('is-disabled');
        } else {
          link.classList.add('is-disabled');
        }
      }
    }

    position() {
      this.headerOffset = getHeaderOffset();
      this.nav.style.top = this.headerOffset + 'px';
    }

    bindEvents() {
      this.nav.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      document.body.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      document.addEventListener('shopify:section:load', this.onResize);
    }

    watchForLateContent() {
      this.resolveItems();
      if (this.items.length === this.links.length) return;

      var self = this;
      var debounceTimer = null;

      this.observer = new MutationObserver(function () {
        if (debounceTimer) return;
        debounceTimer = window.setTimeout(function () {
          debounceTimer = null;
          self.resolveItems();
          self.update();
          if (self.items.length === self.links.length) {
            self.stopWatchingLateContent();
          }
        }, 250);
      });

      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden'],
      });

      this.watchTimeout = window.setTimeout(function () {
        self.stopWatchingLateContent();
      }, 15000);
    }

    stopWatchingLateContent() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.watchTimeout) {
        window.clearTimeout(this.watchTimeout);
        this.watchTimeout = null;
      }
    }

    onClick(event) {
      var link = event.target.closest('[data-pdp-nav-link]');
      if (!link) return;

      var target = resolveTarget(link.dataset.t);
      if (!target) return;

      event.preventDefault();

      var offset = this.headerOffset + this.nav.offsetHeight + EXTRA_GAP;
      target.style.scrollMarginTop = offset + 'px';
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      if (history.pushState) {
        history.pushState(null, '', '#' + link.dataset.t);
      }
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      var self = this;
      window.requestAnimationFrame(function () {
        self.update();
        self.ticking = false;
      });
    }

    onResize() {
      this.position();
      this.update();
    }

    update() {
      if (!this.items.length) return;

      var firstSection = this.items[0].target;
      var revealAt = firstSection.offsetTop + firstSection.offsetHeight * (this.revealPercent / 100);
      var show = getScrollY() >= revealAt;
      this.nav.classList.toggle('show', show);

      var line = window.innerHeight / 2;
      var current = this.items[0];

      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].target.getBoundingClientRect().top <= line) {
          current = this.items[i];
        }
      }

      this.setActive(current.link);
    }

    setActive(link) {
      if (link === this.activeLink) return;

      if (this.activeLink) this.activeLink.classList.remove('on');
      if (link) link.classList.add('on');
      this.activeLink = link;

      if (link) this.centerInTrack(link);
    }

    centerInTrack(link) {
      this.track.scrollTo({
        left: link.offsetLeft - this.track.clientWidth / 2 + link.offsetWidth / 2,
        behavior: 'smooth',
      });
    }
  }

  function init() {
    var navs = document.querySelectorAll('[data-pdp-nav]');
    navs.forEach(function (nav) {
      if (nav.__pdpNavInstance) return;
      nav.__pdpNavInstance = new PdpNav(nav);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
